export default "__VITE_ASSET__DkzCONOx__"